<template>
  <order-body :isOk="false" :codeStatus="600" :pageText="'orderDestroy'">
  </order-body>
</template>

<script>
import orderBody from "_my/order-body";

export default {
  name: "orderDestroy",
  components: {
    orderBody,
  },
};
</script>